import * as types from '../types/lessonPlannerEntity'

// ---- Fetch actions (one per entity) ----

export const fetchPlannerGradeGroupData = (queries, isPaginating, isFiltering, entity) => ({
  type: types.FETCH_PLANNER_GRADE_GROUP_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPlannerGradeGroupDataSuccess = (value, entity) => ({
  type: types.FETCH_PLANNER_GRADE_GROUP_DATA_SUCCESS,
  value,
  entity
})

export const fetchPlannerSubjectData = (queries, isPaginating, isFiltering, entity) => ({
  type: types.FETCH_PLANNER_SUBJECT_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPlannerSubjectDataSuccess = (value, entity) => ({
  type: types.FETCH_PLANNER_SUBJECT_DATA_SUCCESS,
  value,
  entity
})

export const fetchPlannerLayoutData = (queries, isPaginating, isFiltering, entity) => ({
  type: types.FETCH_PLANNER_LAYOUT_DATA,
  queries,
  isPaginating,
  isFiltering,
  entity
})
export const fetchPlannerLayoutDataSuccess = (value, entity) => ({
  type: types.FETCH_PLANNER_LAYOUT_DATA_SUCCESS,
  value,
  entity
})

// ---- Single update action shared across entities ----

export const updatePlannerData = (entity, event, value) => ({
  type: types.UPDATE_PLANNER_DATA,
  entity,
  event,
  value
})
export const updatePlannerDataSuccess = (entity, event, value) => ({
  type: types.UPDATE_PLANNER_DATA_SUCCESS,
  entity,
  event,
  value
})
